export default __webpack_public_path__ + "static/13-2679a18c1266bc20dd9ca24ca64a9d92.webp";